// extracted by mini-css-extract-plugin
export var auto = "_2t-1";
export var spinner = "_2t-0";